import api from "../services/api";
import { createSlice } from "@reduxjs/toolkit";
import { refreshToken } from "../store/user";
import { getPopup } from "../store/popup";

/**
 * Cria um slice com uma função assíncrona
 * @param {Object} config
 * @param {String} config.name
 * @param {Object} config.initialState
 * @param {Object} config.reducers
 * @param {Function} config.fetchConfig
 */
const createAsyncSlice = (config) => {
  const slice = createSlice({
    name: config.name,
    initialState: {
      ...config.initialState,
      error: null,
      loading: false,
    },
    reducers: {
      fetchStart(state, action){
        state.loading = true;
        state.error = null;
      },
      fetchSuccess(state, action) {
        if(action.payload){
          state.data = action.payload;
        }
        state.error = null;
        state.loading = false;
      },
      fetchError(state, action) {
        state.error = action.payload;
        state.loading = false;
      },
      resetState(state) {
        state.data = config.initialState.data;
        state.error = null;
        state.loading = false;
      },
      ...config.reducers,
    },
  });

  const { fetchStart, fetchSuccess, fetchError } = slice.actions;

  const handleError = (err) => {
    return (dispatch) => {
      if (
        config.name !== "auth" &&
        !err?.config.url.includes("refresh-login") &&
        err?.request?.status === 401
      ) {
        dispatch(refreshToken());
      }
      if (err?.response?.data?.message && !err?.config.url.includes("refresh-login")) {
        dispatch(getPopup({ message: err?.response?.data?.message, type: "danger" }));
      }
      
      if(err?.response?.data?.errors?.length > 0 && !err?.config.url.includes("refresh-login")){
        const {errors} = err.response.data

        for(const error of errors){
          dispatch(getPopup({ message:error, type: "danger" }));
        }
      }

      if (
        !err?.response?.data?.message &&
        err?.request?.status !== 401 &&
        !err?.config.url.includes("refresh-login")
      ) {
        dispatch(
          getPopup({
            message: "Falha na execução da ação. Tente novamente.",
            type: "danger",
          })
        );
      }

      return dispatch(fetchError({status: err?.response?.status, data: err?.response?.data}));
    };
  };

  const httpRequest = (payload) => async (dispatch) => {
    dispatch(fetchStart())
    dispatch(getPopup({message: 'Solicitação enviada. Por favor, aguarde!', type: 'warning'}))
    
    return api(payload).then((response) => {
      const { data, status } = response

      if (data?.message) {
        dispatch(getPopup({ message: data?.message, type: "success" }));
      }else if(status === 200){
        dispatch(getPopup({ message: 'Solicitação realizada com sucesso', type: "success" }));
      }

      dispatch(fetchSuccess());
      return data;
    })
    .catch((response) => {
      return handleError(response)(dispatch);
    })
  };

  const asyncAction = (payload) => async (dispatch) => {
      dispatch(fetchStart());

      return api(payload).then(response => {
        const { data } = response

        if (data?.message) {
          dispatch(getPopup({ message: data?.message, type: "success" }));
        }
        return dispatch(fetchSuccess(data));
      }).catch((response) =>{
        return handleError(response)(dispatch);
      } )
  };

  return { ...slice, asyncAction, httpRequest };
};

export default createAsyncSlice;
